var map = {
	".": "GHqA",
	"./": "GHqA",
	"./03_get_deposit_hisrec": "ZlbJ",
	"./03_get_deposit_hisrec.json": "ZlbJ",
	"./04_get_withdraw_history": "DNed",
	"./04_get_withdraw_history.json": "DNed",
	"./05_post_wallets_coins": "BYvq",
	"./05_post_wallets_coins.json": "BYvq",
	"./06_post_wallets_withdraw": "yxdj",
	"./06_post_wallets_withdraw.json": "yxdj",
	"./13.get_wallet_queryDepositAddress": "WnFl",
	"./13.get_wallet_queryDepositAddress.json": "WnFl",
	"./14_get_risk_deposit_records": "JbVL",
	"./14_get_risk_deposit_records.json": "JbVL",
	"./index": "GHqA",
	"./index.js": "GHqA"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aLYx";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/spot/api/wallet ^.*$
// module id = aLYx
// module chunks = 3